<template>
  <div class="nav-container full-width-section">
    <div class="nav-trigger">
      <div class="logo-container">
        <img src="@/assets/fabet_logo.png" alt="fabet logo" class="nav-logo">
      </div>
      
      <div class="nav-links-wrapper desktop-nav">
        <div class="nav-links">
          <div v-for="(item, index) in menuItems" :key="index" class="line" :class="{ 'disabled': !item.isActive }">
            <h3 
              :class="{
                'active': currentPath === item.path,
                'product-center-menu': item.path === '/products'
              }"
              @click="navigateTo(item.path)"
            >
              {{ getItemTitle(item.path) }}
            </h3>
            <nav class="main-nav" v-if="item.path === '/products'" :class="{ 'show': showDropdown }">
              <div class="product-categories">
                <h3 :class="{ 'active': currentCategory === 'machine' }" @mouseover="showCategory('machine')" @click="showCategory('machine')" style="cursor: pointer;">{{ getCategoryTitle('machine') }}</h3>
                <h3 :class="{ 'active': currentCategory === 'middleware' }" @mouseover="showCategory('middleware')" @click="showCategory('middleware')" style="cursor: pointer;">{{ getCategoryTitle('middleware') }}</h3>
                <h3 :class="{ 'active': currentCategory === 'sensor' }" @mouseover="showCategory('sensor')" @click="showCategory('sensor')" style="cursor: pointer;">{{ getCategoryTitle('sensor') }}</h3>
              </div>
              <section class="mac-list" v-show="currentCategory === 'machine'" :key="'machine-section'">
                <div v-for="product in machineProducts" :key="'machine-' + product.id" class="mac-card">
                  <div class="product-image-container" @click="handleProductClick(product, $event)"><img :src="product.imageUrl" :alt="product.title" style="cursor: pointer;" /></div>
                  <div class="product-title-container"><h3 @click="handleProductClick(product, $event)" style="cursor: pointer;" v-html="formatProductTitle(product)"></h3></div>
                  <div class="links">
                    <a href="javascript:void(0)" @click="handleProductClick(product, $event)">{{ getLearnMoreText() }}</a>
                  </div>
                </div>
              </section>
              <section class="mac-list" v-show="currentCategory === 'middleware'" :key="'middleware-section'">
                <div v-for="product in middlewareProducts" :key="'middleware-' + product.id" class="mac-card">
                  <div class="product-image-container" @click="handleProductClick(product, $event)"><img :src="product.imageUrl" :alt="product.title" style="cursor: pointer;" /></div>
                  <div class="product-title-container"><h3 @click="handleProductClick(product, $event)" style="cursor: pointer;" v-html="formatProductTitle(product)"></h3></div>
                  <div class="links">
                    <a href="javascript:void(0)" @click="handleProductClick(product, $event)">{{ getLearnMoreText() }}</a>
                  </div>
                </div>
              </section>
              <section class="mac-list" v-show="currentCategory === 'sensor'" :key="'sensor-section'">
                <div v-for="product in sensorProducts" :key="'sensor-' + product.id" class="mac-card">
                  <div class="product-image-container" @click="handleProductClick(product, $event)"><img :src="product.imageUrl" :alt="product.title" style="cursor: pointer;" /></div>
                  <div class="product-title-container"><h3 @click="handleProductClick(product, $event)" style="cursor: pointer;" v-html="formatProductTitle(product)"></h3></div>
                  <div class="links">
                    <a href="javascript:void(0)" @click="handleProductClick(product, $event)">{{ getLearnMoreText() }}</a>
                  </div>
                </div>
              </section>
            </nav>
          </div>
        </div>
        <div class="language-selector">
          <div class="language-label" @click="toggleLanguageDropdown">
            <span>{{ currentLanguageLabel }}</span>
            <span class="arrow" :class="{ 'rotate': showLanguageDropdown }">▼</span>
          </div>
          <div class="language-dropdown" :class="{ 'show': showLanguageDropdown }">
            <div v-for="(lang, code) in languages" :key="code" class="language-item" @click="changeLanguage(code)">
              {{ lang }}
            </div>
          </div>
        </div>
      </div>
      
      <div class="mobile-nav">
        <div class="hamburger-menu" @click="toggleMobileMenu" :class="{ 'active': showMobileMenu }">
          <span></span>
          <span></span>
          <span></span>
        </div>
        
        <div class="mobile-language-selector">
          <div class="mobile-language-label" @click="toggleMobileLanguageDropdown">
            <span>{{ currentLanguageLabel }}</span>
            <span class="arrow" :class="{ 'rotate': showMobileLanguageDropdown }">▼</span>
          </div>
          <div class="mobile-language-dropdown" :class="{ 'show': showMobileLanguageDropdown }">
            <div v-for="(lang, code) in languages" :key="code" class="mobile-language-item" @click="changeLanguage(code)">
              {{ lang }}
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="mobile-sidebar" :class="{ 'show': showMobileMenu }" @click="closeMobileMenu">
      <div class="mobile-sidebar-content" @click.stop>
        <div class="mobile-menu-header">
          <img src="@/assets/fabet_logo.png" alt="fabet logo" class="mobile-nav-logo">
          <button class="close-btn" @click="closeMobileMenu">×</button>
        </div>
        
        <div class="mobile-menu-items">
          <div v-for="(item, index) in menuItems" :key="index" class="mobile-menu-item" :class="{ 'disabled': !item.isActive }">
            <h3 
              :class="{
                'active': currentPath === item.path,
                'mobile-product-menu': item.path === '/products'
              }"
              @click="handleMobileMenuClick(item.path)"
            >
              {{ getItemTitle(item.path) }}
            </h3>
            
            <div class="mobile-submenu" v-if="item.path === '/products' && showMobileProductMenu">
              <div class="mobile-product-categories">
                <h4 :class="{ 'active': currentCategory === 'machine' }" @click="showCategory('machine')">{{ getCategoryTitle('machine') }}</h4>
                <h4 :class="{ 'active': currentCategory === 'middleware' }" @click="showCategory('middleware')">{{ getCategoryTitle('middleware') }}</h4>
                <h4 :class="{ 'active': currentCategory === 'sensor' }" @click="showCategory('sensor')">{{ getCategoryTitle('sensor') }}</h4>
              </div>
              
              <div class="mobile-product-list" v-if="currentCategory === 'machine'">
                <div v-for="product in machineProducts" :key="product.id" class="mobile-product-item" @click="handleProductClick(product)">
                  <img :src="product.imageUrl" :alt="product.title" />
                  <span v-html="formatProductTitle(product)"></span>
                </div>
              </div>
              
              <div class="mobile-product-list" v-if="currentCategory === 'middleware'">
                <div v-for="product in middlewareProducts" :key="product.id" class="mobile-product-item" @click="handleProductClick(product)">
                  <img :src="product.imageUrl" :alt="product.title" />
                  <span v-html="formatProductTitle(product)"></span>
                </div>
              </div>
              
              <div class="mobile-product-list" v-if="currentCategory === 'sensor'">
                <div v-for="product in sensorProducts" :key="product.id" class="mobile-product-item" @click="handleProductClick(product)">
                  <img :src="product.imageUrl" :alt="product.title" />
                  <span v-html="formatProductTitle(product)"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getAllProducts } from '@/api/product';
import { useI18n } from 'vue-i18n';

const router = useRouter();
const route = useRoute();
const { locale } = useI18n();

const currentCategory = ref('machine');
const menuItems = ref([]);
const products = ref([]);
const machineProducts = ref([]);
const middlewareProducts = ref([]);
const sensorProducts = ref([]);
const loading = ref(true);
const error = ref('');
const showDropdown = ref(false);

const showLanguageDropdown = ref(false);

const showMobileMenu = ref(false);
const showMobileLanguageDropdown = ref(false);
const showMobileProductMenu = ref(false);

const languages = computed(() => {
  return {
    'zh': '中文',
    'en': 'English'
  };
});

const currentLanguageLabel = computed(() => {
  return languages.value[locale.value];
});

const currentPath = computed(() => {
  return route.path;
});

const menuTranslations = {
  '/': {
    'zh': '首页',
    'en': 'Home'
  },
  '/products': {
    'zh': '产品中心',
    'en': 'Products'
  },
  '/solution': {
    'zh': '解决方案',
    'en': 'Solutions'
  },
  '/tech-support': {
    'zh': '技术支持',
    'en': 'Technical Support'
  },
  '/contact': {
    'zh': '关于我们',
    'en': 'About Us'
  }
};

const categoryTranslations = {
  'machine': {
    'zh': '智能通道系统',
    'en': 'Intelligent Channel Systems'
  },
  'middleware': {
    'zh': '物联网中间件',
    'en': 'IoT Middleware'
  },
  'sensor': {
    'zh': '传感器及组件',
    'en': 'Sensors & Components'
  }
};

const buttonTranslations = {
  'learnMore': {
    'zh': '了解更多',
    'en': 'Learn More'
  }
};

const errorTranslations = {
  'fetchFailed': {
    'zh': '获取产品数据失败',
    'en': 'Failed to fetch product data'
  }
};

const getItemTitle = (path) => {
  if (menuTranslations[path]) {
    return menuTranslations[path][locale.value] || menuTranslations[path]['zh'];
  }
  return path;
};

const getCategoryTitle = (categoryId) => {
  if (categoryTranslations[categoryId]) {
    return categoryTranslations[categoryId][locale.value] || categoryTranslations[categoryId]['zh'];
  }
  return categoryId;
};

const getLearnMoreText = () => {
  return buttonTranslations['learnMore'][locale.value] || buttonTranslations['learnMore']['zh'];
};

const getErrorText = (errorKey) => {
  if (errorTranslations[errorKey]) {
    return errorTranslations[errorKey][locale.value] || errorTranslations[errorKey]['zh'];
  }
  return errorKey;
};

const loadMenuItems = () => {
  const savedMenu = localStorage.getItem('navbarMenu');
  if (savedMenu) {
    menuItems.value = JSON.parse(savedMenu);
  } else {
    // 默认数据
    menuItems.value = [
      { path: '/', isActive: true },
      { path: '/products', isActive: true },
      { path: '/solution', isActive: true },
      { path: '/tech-support', isActive: true },
      { path: '/contact', isActive: true }
    ];
  }
};

const fetchProducts = async () => {
  try {
    loading.value = true;
    const currentLang = locale.value === 'en' ? 'en' : 'zh';
    const response = await getAllProducts(currentLang);
    products.value = response.data;
    
    const machineCategory = categoryTranslations['machine'][currentLang];
    const middlewareCategory = categoryTranslations['middleware'][currentLang];
    const sensorCategory = categoryTranslations['sensor'][currentLang];
    
    // 过滤产品，匹配当前语言下的分类名称
    machineProducts.value = products.value.filter(product => {
      const matches = product.model === machineCategory;
      if (!matches && currentLang === 'en') {
        // 如果英文匹配失败，尝试匹配中文（兼容旧数据）
        return product.model === categoryTranslations['machine']['zh'];
      }
      return matches;
    }).slice(0, 4);
    
    middlewareProducts.value = products.value.filter(product => {
      const matches = product.model === middlewareCategory;
      if (!matches && currentLang === 'en') {
        return product.model === categoryTranslations['middleware']['zh'];
      }
      return matches;
    }).slice(0, 4);
    
    sensorProducts.value = products.value.filter(product => {
      const matches = product.model === sensorCategory;
      if (!matches && currentLang === 'en') {
        return product.model === categoryTranslations['sensor']['zh'];
      }
      return matches;
    }).slice(0, 4);
  } catch (err) {
    error.value = getErrorText('fetchFailed');
    machineProducts.value = [];
    middlewareProducts.value = [];
    sensorProducts.value = [];
  } finally {
    loading.value = false;
  }
};

const navigateTo = (path) => {
  router.push(path);
};

const handleProductClick = (product, event) => {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  if (!product || !product.id) {
    return;
  }
  
  // 直接跳转到产品详情页
  navigateToProduct(product.id);
};

const navigateToProduct = (productId) => {
  showDropdown.value = false;
  router.push(`/product/${productId}`).catch(() => {});
  closeMobileMenu();
};

const showCategory = (category) => {
  currentCategory.value = category;
  
  if (route.path === '/products') {
    showDropdown.value = true;
    
    const categoryToModel = {
      'machine': categoryTranslations['machine']['zh'],
      'middleware': categoryTranslations['middleware']['zh'],
      'sensor': categoryTranslations['sensor']['zh']
    };
    
    const modelName = categoryToModel[category];
    if (modelName) {
      setTimeout(() => {
        const event = new CustomEvent('category-changed', { 
          detail: { model: modelName, category: category },
          bubbles: true,
          cancelable: true
        });
        window.dispatchEvent(event);
      }, 50);
    }
  }
};

const toggleLanguageDropdown = () => {
  showLanguageDropdown.value = !showLanguageDropdown.value;
};

const changeLanguage = (langCode) => {
  locale.value = langCode;
  localStorage.setItem('language', langCode);
  showLanguageDropdown.value = false;
  showMobileLanguageDropdown.value = false;
  fetchProducts();
  window.dispatchEvent(new CustomEvent('languageChanged'));
};

const toggleMobileMenu = () => {
  showMobileMenu.value = !showMobileMenu.value;
  if (showMobileMenu.value) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
    showMobileProductMenu.value = false;
  }
};

const closeMobileMenu = () => {
  showMobileMenu.value = false;
  showMobileProductMenu.value = false;
  document.body.style.overflow = '';
};

const toggleMobileLanguageDropdown = () => {
  showMobileLanguageDropdown.value = !showMobileLanguageDropdown.value;
};

const handleMobileMenuClick = (path) => {
  if (path === '/products') {
    showMobileProductMenu.value = !showMobileProductMenu.value;
  } else {
    navigateTo(path);
    closeMobileMenu();
  }
};

const loadUserLanguage = () => {
  const savedLang = localStorage.getItem('language');
  if (savedLang && ['zh', 'en'].includes(savedLang)) {
    locale.value = savedLang;
  }
};

const setupEventListeners = () => {
  const getProductCenterMenu = () => document.querySelector('.product-center-menu');
  const getMainNav = () => document.querySelector('.main-nav');
  
  const attemptSetup = () => {
    const productCenterMenu = getProductCenterMenu();
    if (!productCenterMenu) {
      setTimeout(attemptSetup, 100);
      return;
    }
    
    productCenterMenu.addEventListener('mouseenter', () => {
      showDropdown.value = true;
    });
    
    const hideDropdownHandler = () => {
      setTimeout(() => {
        const menu = getProductCenterMenu();
        const nav = getMainNav();
        if (!menu || !nav) return;
        
        const isHoveringMenu = menu.matches(':hover');
        const isHoveringDropdown = nav.matches(':hover');
        
        if (!isHoveringMenu && !isHoveringDropdown) {
          showDropdown.value = false;
        }
      }, 200);
    };
    
    productCenterMenu.addEventListener('mouseleave', hideDropdownHandler);
    
    setTimeout(() => {
      const mainNav = getMainNav();
      if (mainNav) {
        mainNav.addEventListener('mouseenter', () => {
          showDropdown.value = true;
        });
        mainNav.addEventListener('mouseleave', hideDropdownHandler);
      }
    }, 50);
    
    document.addEventListener('click', (e) => {
      const menu = getProductCenterMenu();
      const nav = getMainNav();
      const languageSelector = document.querySelector('.language-selector');
      
      if (!menu || !nav) return;
      
      if (!menu.contains(e.target) && !nav.contains(e.target)) {
        showDropdown.value = false;
      }
      
      if (languageSelector && !languageSelector.contains(e.target)) {
        showLanguageDropdown.value = false;
      }
    });
  };
  
  attemptSetup();
};

const formatProductTitle = (product) => {
  if (!product) return '';
  
  let title = product.title || '';
  
  if (locale.value === 'en') {
    if (/[\u4e00-\u9fa5]/.test(title)) {
      if (product.titleEn && product.titleEn.trim() !== '') {
        title = product.titleEn;
      }
    }
  } else {
    if (!/[\u4e00-\u9fa5]/.test(title) && /^[A-Za-z0-9\s\-.,()]+$/.test(title)) {
      title = product.titleZh || title;
    }
  }
  
  const englishPattern = /[A-Za-z][A-Za-z0-9-]+/;
  const match = title.match(englishPattern);
  
  if (match && match.index > 0) {
    const chinesePart = title.substring(0, match.index);
    const englishPart = title.substring(match.index);
    return `${chinesePart}<br>${englishPart}`;
  }
  
  return title;
};

watch(locale, () => {
  fetchProducts();
});

watch(() => route.path, (newPath, oldPath) => {
  if (oldPath && oldPath.startsWith('/product/') && !newPath.startsWith('/product/')) {
    currentCategory.value = 'machine';
    if (newPath === '/products') {
      showDropdown.value = true;
      fetchProducts();
    }
  } else if (newPath.startsWith('/product/')) {
    showDropdown.value = false;
  } else if (newPath === '/products') {
    setTimeout(() => {
      showDropdown.value = true;
    }, 150);
  }
});

onMounted(() => {
  loadUserLanguage();
  loadMenuItems();
  fetchProducts();
  
  setTimeout(() => {
    setupEventListeners();
  }, 100);
  
  window.addEventListener('storage', (e) => {
    if (e.key === 'navbarMenu' || e.key === 'language') {
      loadMenuItems();
      loadUserLanguage();
      fetchProducts();
      setupEventListeners();
    }
  });
});
</script>

<style scoped lang="scss">
@import '@/styles/nav_section';

.product-center-menu {
  position: relative;
}

.product-title-container h3 {
  line-height: 1.4;
  margin: 0;
}

.nav-links-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 40px; /* 整体右侧留出40px空间 */
}

.language-selector {
  display: flex;
  align-items: center; /* 垂直居中 */
  height: 100%; /* 确保高度充满父容器 */
  margin-left: auto; /* 自动填充左侧空间，将语言选择器推到最右侧 */
  position: relative;
}

.language-label {
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #333;
  font-size: 14px;
  padding: 0 10px;
  height: 100%;
}

.language-label .arrow {
  margin-left: 5px;
  transition: transform 0.2s ease;
  font-size: 10px;
}

.language-label .arrow.rotate {
  transform: rotate(180deg);
}

.language-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  overflow: hidden;
  display: none;
  z-index: 1000;
  min-width: 100px;
}

.language-dropdown.show {
  display: block;
}

.language-item {
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: background-color 0.2s ease;
}

.language-item:hover {
  background-color: #f5f5f5;
}

.desktop-nav {
  display: flex;
}

.mobile-nav {
  display: none;
}

.mobile-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  
  &.show {
    opacity: 1;
    visibility: visible;
  }
}

.mobile-sidebar-content {
  position: absolute;
  top: 0;
  right: 0;
  width: 280px;
  height: 100%;
  background: white;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  overflow-y: auto;
  
  .mobile-sidebar.show & {
    transform: translateX(0);
  }
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e9ecef;
  
  .mobile-nav-logo {
    height: 30px;
    width: auto;
    object-fit: contain;
    display: block;
  }
  
  .close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
      color: #333;
    }
  }
}

.mobile-menu-items {
  padding: 20px 0;
}

.mobile-menu-item {
  border-bottom: 1px solid #f1f1f1;
  
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  
  h3 {
    padding: 15px 20px;
    margin: 0;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    
    &:hover {
      background: #f8f9fa;
    }
    
    &.active {
      color: #007bff;
      background: #f8f9fa;
    }
  }
}

.mobile-submenu {
  background: #f8f9fa;
  padding: 10px 0;
}

.mobile-product-categories {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 15px;
  
  h4 {
    padding: 10px 30px;
    margin: 0;
    font-size: 14px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    
    &:hover {
      background: #e9ecef;
    }
    
    &.active {
      color: #007bff;
      background: #e9ecef;
    }
  }
}

.mobile-product-list {
  padding: 0 20px;
}

.mobile-product-item {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-bottom: 10px;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  
  &:hover {
    background: #f1f1f1;
  }
  
  img {
    width: 50px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
    margin-right: 12px;
  }
  
  span {
    font-size: 14px;
    line-height: 1.3;
  }
}

@media (max-width: 768px) {
  .desktop-nav {
    display: none;
  }
  
  .mobile-nav {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  .hamburger-menu {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 24px;
    height: 18px;
    cursor: pointer;
    transition: all 0.3s ease;
    
    span {
      display: block;
      height: 2px;
      width: 100%;
      background-color: #333;
      border-radius: 1px;
      transition: all 0.3s ease;
      transform-origin: center;
    }
    
    &.active {
      span:nth-child(1) {
        transform: rotate(45deg) translate(5px, 5px);
      }
      
      span:nth-child(2) {
        opacity: 0;
      }
      
      span:nth-child(3) {
        transform: rotate(-45deg) translate(7px, -6px);
      }
    }
  }
  
  .mobile-language-selector {
    position: relative;
    
    .mobile-language-label {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 5px 10px;
      background: #f8f9fa;
      border: 1px solid #dee2e6;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      transition: all 0.3s ease;
      
      &:hover {
        background: #e9ecef;
      }
      
      .arrow {
        font-size: 10px;
        transition: transform 0.3s ease;
        
        &.rotate {
          transform: rotate(180deg);
        }
      }
    }
    
    .mobile-language-dropdown {
      position: absolute;
      top: 100%;
      right: 0;
      background: white;
      border: 1px solid #dee2e6;
      border-radius: 4px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      z-index: 1000;
      min-width: 80px;
      opacity: 0;
      visibility: hidden;
      transform: translateY(-10px);
      transition: all 0.3s ease;
      
      &.show {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }
      
      .mobile-language-item {
        padding: 8px 12px;
        cursor: pointer;
        font-size: 12px;
        transition: background-color 0.3s ease;
        
        &:hover {
          background: #f8f9fa;
        }
        
        &:first-child {
          border-radius: 4px 4px 0 0;
        }
        
        &:last-child {
          border-radius: 0 0 4px 4px;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .nav-container {
    padding: 0 8px;
    min-height: 55px;
  }
  
  .nav-trigger {
    padding: 6px 0;
    gap: 8px;
  }
  
  .logo-container {
    margin-bottom: 6px;
  }
  
  .nav-logo {
    max-height: 30px;
    width: auto !important;
    height: auto !important;
    object-fit: contain !important;
  }
  
  .nav-links {
    gap: 6px;
    margin-right: 8px;
  }
  
  .line h3 {
    font-size: 12px;
    padding: 5px 6px;
  }
  
  .language-selector {
    flex-shrink: 0;
  }
  
  .language-label {
    font-size: 12px;
    padding: 5px 8px;
  }
  
  .main-nav {
    padding: 10px;
  }
  
  .product-categories h3 {
    font-size: 13px;
    padding: 6px 0;
  }
  
  .mac-card {
    padding: 8px;
  }
  
  .product-image-container {
    flex: 0 0 70px;
    margin-right: 10px;
  }
  
  .product-image-container img {
    width: 70px;
    height: 50px;
  }
  
  .product-title-container h3 {
    font-size: 13px;
  }
  
  .links a {
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .language-label {
    font-size: 13px;
    padding: 6px 10px;
  }
}
</style>